export default __webpack_public_path__ + "static/media/icon-logout.d870f7f1.svg";